import { STORAGE_KEYS } from "../constants/storageKeys";

const DEFAULT_LANGUAGE = "zh";

export function getAuthPayload(Tool) {
  return {
    marketer_id: Tool.getStorage(STORAGE_KEYS.MARKETER_ID),
    staffer_id: Tool.getStorage(STORAGE_KEYS.STAFFER_ID),
    re_postbe_id: Tool.getStorage(STORAGE_KEYS.RE_POSTBE_ID),
    token: Tool.getStorage(STORAGE_KEYS.TOKEN),
    company_id: Tool.getStorage(STORAGE_KEYS.COMPANY_ID),
    school_id: Tool.getStorage(STORAGE_KEYS.SCHOOL_ID),
    postbe_crmuserlevel: Tool.getStorage(STORAGE_KEYS.POSTBE_CRMLEVEL),
    language_type: Tool.getStorage(STORAGE_KEYS.LANGUAGE) || DEFAULT_LANGUAGE,
  };
}

export function appendGetParams(config, payload) {
  const params = config.params || {};
  Object.keys(payload).forEach((key) => {
    if (params[key] == null && payload[key] != null) {
      params[key] = payload[key];
    }
  });
  config.params = params;
}

function appendPostString(data, marker, queryPart) {
  if (data.indexOf(marker) >= 0) {
    return data;
  }
  return `${data}&${queryPart}`;
}

export function appendPostBody(config, payload) {
  let data = config.data;
  data = appendPostString(data, "re_postbe_id=", `re_postbe_id=${payload.re_postbe_id}`);
  data = appendPostString(data, "token=", `token=${payload.token}`);
  data = appendPostString(data, "company_id=", `company_id=${payload.company_id}`);
  data = appendPostString(data, "&marketer_id=", `marketer_id=${payload.marketer_id}`);
  data = appendPostString(data, "staffer_id=", `staffer_id=${payload.staffer_id}`);
  data = appendPostString(data, "school_id=", `school_id=${payload.school_id}`);
  data = appendPostString(
    data,
    "postbe_crmuserlevel=",
    `postbe_crmuserlevel=${payload.postbe_crmuserlevel}`
  );
  data = appendPostString(data, "language_type=", `language_type=${payload.language_type}`);
  config.data = data;
}

export function appendJavaHeaders(config, payload) {
  const headers = config.headers || {};
  headers.token = payload.token || "";
  headers.company_id = payload.company_id || "";
  headers.marketer_id = payload.marketer_id || "";
  config.headers = headers;
}
